// project import
import dashboard from './dashboard';
import management from './management';
import userManagement from './userManagement';
import reports from './reports';
import settings from './settings';
import pages from './page';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, management, reports, userManagement, settings, pages]
};

export default menuItems;

